import React from 'react';
import {useTranslation} from 'react-i18next';
import AppIcon from './AppIcon';

const BetaIcon = () => {
  const {t} = useTranslation();
  const label = t('ThisIsABetaFeature');
  return <AppIcon name="lab" title={label} aria-label={label} style={{cursor: 'help'}} />;
};

export default BetaIcon;
